import React from "react";
import SnacksCardList from "../components/SnacksCardList";

const Snacks = () => {
  return <SnacksCardList  />;
};

export default Snacks;